module.exports = __webpack_public_path__ + "img/loginpanel2.1a8092fa.png";